import useSWR, { useSWRConfig } from 'swr'
import { useState, useContext } from 'react'
import Link from 'next/link'

import Navbar from 'components/navbar'
import Layout, { Textlayout } from 'components/layout'
import Pagetitle from 'components/pageTitle'
import Footer from 'components/footer'
import Seo from 'components/seo'
import { CartContext } from '@/context/cart'
import ShopifyImage from '@/components/shop/shopifyImage'
import Button from '@/components/ui/button'
import { trackGoal } from 'fathom-client'
import { removeFromBag } from 'lib/shop/cartCommon'

const fetcher = (...args) => fetch(...args).then((res) => res.json())

export default function merciShop() {
  return (
    <>
      <Seo title="Panier" description="" canonical="/shop/panier">
        <meta name="robots" content="noindex" />
      </Seo>
      <div className="overflow-hidden">
        <Navbar />
        <main className="relative mt-12 min-h-[50vh] md:mt-24">
          <Layout>
            <Pagetitle>Panier</Pagetitle>

            <div className="mt-16">
              <Bag />
            </div>
          </Layout>
        </main>
        <div className="mt-32">
          <Footer />
        </div>
      </div>
    </>
  )
}

const Bag = () => {
  const [cartId, setCartId] = useContext(CartContext)
  const { data, error } = useSWR('/api/shop/cart?cartId=' + cartId, fetcher, { revalidateOnFocus: false })

  if (error)
    return (
      <div className="text-center text-lg font-medium">
        Un petit souci est survenu pour charger votre panier, réessayez plus tard.
      </div>
    )
  if (!data) return <div className="text-center">Chargement de votre panier...</div>

  if (!data?.cart?.lines?.edges.length > 0)
    return <div className="text-center text-lg font-medium">Votre panier est vide !</div>

  // render data
  return (
    <div className="grid grid-cols-6 gap-12">
      <div className="col-span-6 lg:col-span-4">
        <ul className="space-y-4">
          {data?.cart?.lines?.edges?.map(({ node: thisLine }) => (
            <LineItem key={thisLine.id} line={thisLine} swrData={data} />
          ))}
        </ul>
      </div>
      <div className="col-span-6 lg:col-span-2">
        <div className="bg-yellow-50 p-6">
          <div className="flex justify-between">
            <h2 className="text-lg font-medium">Total du panier :</h2>
            <div>
              {parseFloat(data.cart.cost.totalAmount.amount).toLocaleString('fr-BE', {
                style: 'currency',
                currency: 'EUR'
              })}
            </div>
          </div>
          {/* <div className="text-right text-sm italic text-gray-700">
            (Incluant{' '}
            {parseFloat(data.cart.cost.totalTaxAmount.amount).toLocaleString('fr-BE', {
              style: 'currency',
              currency: 'EUR'
            })}{' '}
            de tax)
          </div> */}

          <Button className="mt-6" type="outline" href={data.cart.checkoutUrl}>
            Passer commande
          </Button>
        </div>
      </div>
    </div>
  )
}

const LineItem = ({ line, swrData }) => {
  const { mutate } = useSWRConfig()
  const [isLoading, setIsLoading] = useState(false)
  const [cartId, setCartId] = useContext(CartContext)

  const onRemove = ({ id }) => {
    trackGoal('XLXTZMCH')
    setIsLoading(true)
    removeFromBag({ lineId: id, cartId })
      .then((newCart) => {
        mutate('/api/shop/cart?cartId=' + cartId, { ...swrData, cart: newCart })
        setIsLoading(false)
      })
      .catch((error) => {
        console.error('An error occured while removing from cart.', error)
        setIsLoading(false)
      })
  }

  return (
    <li className="relative flex">
      <Link href={`/shop/product/` + line.merchandise.product.handle}>
        <a>
          <div className="h-auto w-32 md:w-40">
            <ShopifyImage imageData={line.merchandise.product.featuredImage} />
          </div>
        </a>
      </Link>
      <div className="ml-4 flex w-full items-start justify-between">
        <div className="flex h-full flex-col justify-between">
          <h2 className="font-serif text-sm font-medium md:text-base">{line.merchandise.product.title}</h2>

          <p className="pb-6">
            <span className="text-sm text-gray-700">{line.quantity} x </span>
            {parseFloat(line.merchandise.priceV2.amount).toLocaleString('fr-BE', {
              style: 'currency',
              currency: 'EUR'
            })}
          </p>
        </div>
        <button className="pt-1" onClick={() => onRemove({ id: line.id })}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </button>
      </div>

      {isLoading ? (
        <div className="absolute z-20 flex h-full w-full items-center justify-center bg-orange-50/25 object-cover backdrop-blur">
          <svg
            className="inline-block h-5 w-5 animate-spin text-orange"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24">
            <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      ) : null}
    </li>
  )
}
